import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-wrap" }
const _hoisted_2 = { class: "flex mr-3 pt-2" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]

import { ref, toRefs } from 'vue';
import Calendar from 'primevue/calendar';
import { useUtilizationStore } from '@/store';
import { useDateTime, usePersonTypes } from '@/composables';
import { SOWReportingSPTableInterface } from '@/types';

interface TimeUsageModalPropsInterface {
  sowData: SOWReportingSPTableInterface[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SOWReportingServiceProvider',
  props: {
    sowData: {}
  },
  setup(__props: any) {

const props = __props;
const { sowData } = toRefs(props);

const utilizationStore = useUtilizationStore();
const maxDate = ref<Date>(useDateTime().getMostRecentSunday());
const minDate = ref<Date>(new Date('2024-01-02'));
const dateSelect = ref<Date>(new Date(utilizationStore.serviceProviderSOWFilterDate));

const definePercentageClass = (sow_utilization: number) => {
  if (sow_utilization > 100) {
    return 'text-red-600';
  }

  if (sow_utilization < 50) {
    return 'text-orange-600';
  }

  return '';
};

const onDateSelect = async (value: Date) => {
  dateSelect.value = value;
  await utilizationStore.updateServiceProviderSOWFilterDate(dateSelect.value);
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Card, { class: "flex-none flex flex-column" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Icon, {
            name: "query_stats",
            class: "material-icons text-color-blue mr-2"
          }),
          _cache[1] || (_cache[1] = _createElementVNode("h2", { textContent: 'SOW Reporting up to:' }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Calendar), {
            modelValue: dateSelect.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateSelect).value = $event)),
            "show-icon": "",
            "disabled-days": [1, 2, 3, 4, 5, 6],
            "icon-display": "input",
            class: "text-sm",
            "date-format": "MM dd, yy",
            "max-date": maxDate.value,
            "min-date": minDate.value,
            onDateSelect: onDateSelect
          }, null, 8, ["modelValue", "max-date", "min-date"])
        ])
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        value: _unref(sowData),
        "data-id": "contract_id",
        "responsive-layout": "scroll",
        "sort-field": "billed_hours_percent",
        "sort-order": -1
      }, {
        empty: _withCtx(() => [...(_cache[7] || (_cache[7] = [
          _createElementVNode("span", { textContent: 'No data to display' }, null, -1)
        ]))]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "organization",
            header: "Organization",
            sortable: ""
          }),
          _createVNode(_component_Column, {
            field: "contract_quote_number",
            header: "Contract",
            sortable: ""
          }),
          (!_unref(usePersonTypes).isClinician())
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 0,
                field: "contract_type",
                header: "Type",
                sortable: ""
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Column, {
            field: "sow_hours",
            "header-class": "relative",
            sortable: ""
          }, {
            header: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("span", null, "SOW Hrs/Wk", -1)),
              _withDirectives(_createVNode(_component_Icon, {
                name: "info",
                class: "absolute right-0 top-0 mt-2 mr-1 text-gray-400 text-base cursor-pointer"
              }, null, 512), [
                [
                  _directive_tooltip,
                  
                'Hrs from the SOW for this contract. This is the maximum number of billable hours. SP can bill for actual hours worked, not exceeding this maximum, tracked as average hours/week throughout the school year. Billing is based on actual hours worked'
              ,
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "weeks",
            "header-class": "relative",
            sortable: ""
          }, {
            header: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "Weeks", -1)),
              _withDirectives(_createVNode(_component_Icon, {
                name: "info",
                class: "absolute right-0 top-0 mt-2 mr-1 text-gray-400 text-base cursor-pointer"
              }, null, 512), [
                [
                  _directive_tooltip,
                  '# of weeks of documented events',
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "billed_hours_total_wo_eval",
            header: "Hrs (Non-Eval)",
            "header-class": "relative",
            sortable: ""
          }),
          _createVNode(_component_Column, {
            field: "eval_hours",
            header: "Eval Hrs",
            "header-class": "relative",
            sortable: ""
          }),
          _createVNode(_component_Column, {
            field: "billed_hours_total",
            "header-class": "relative",
            sortable: ""
          }, {
            header: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "Total Billed Hrs", -1)),
              _withDirectives(_createVNode(_component_Icon, {
                name: "info",
                class: "absolute right-0 top-0 mt-2 mr-1 text-gray-400 text-base cursor-pointer"
              }, null, 512), [
                [
                  _directive_tooltip,
                  
                'Total number of hours billed for this contract. Excludes Eval Hrs for Per Student contracts.'
              ,
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "billed_hours_diff",
            header: "Hrs +/-",
            "header-class": "relative",
            sortable: ""
          }),
          _createVNode(_component_Column, {
            field: "billed_hours_percent",
            "header-class": "relative",
            sortable: ""
          }, {
            header: _withCtx(() => [
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "%", -1)),
              _withDirectives(_createVNode(_component_Icon, {
                name: "info",
                class: "absolute right-0 top-0 mt-2 mr-1 text-gray-400 text-base cursor-pointer"
              }, null, 512), [
                [
                  _directive_tooltip,
                  'Comparison of Total Billed Hours to SOW Hrs/Wk x Weeks',
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            body: _withCtx(({ data }) => [
              _createElementVNode("span", {
                class: _normalizeClass(definePercentageClass(data.billed_hours_percent)),
                textContent: _toDisplayString(`${data.billed_hours_percent ? data.billed_hours_percent + '%' : 'N/A'}`)
              }, null, 10, _hoisted_4)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "billed_hours_average",
            "header-class": "relative",
            sortable: ""
          }, {
            header: _withCtx(() => [
              _cache[6] || (_cache[6] = _createElementVNode("span", null, "Avg Hrs/Wk (prior 3 mths)", -1)),
              _withDirectives(_createVNode(_component_Icon, {
                name: "info",
                class: "absolute right-0 top-0 mt-2 mr-1 text-gray-400 text-base cursor-pointer"
              }, null, 512), [
                [
                  _directive_tooltip,
                  'Average hours billed/week for prior 3 months',
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            body: _withCtx(({ data }) => [
              _createElementVNode("span", {
                textContent: _toDisplayString(`${data.billed_hours_average ? data.billed_hours_average : 'N/A'}`)
              }, null, 8, _hoisted_5)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }))
}
}

})